export default "__VITE_ASSET__gYBVsOp6__"